import { Tooltip } from '@hydrodigital/design-system';
import HealthIndicator from '../HealthIndicator';

interface SourceHealthCellProps {
	health: number;
	size?: 'sm' | 'lg';
}

export const SourceHealthCell = ({ health, size = 'lg' }: SourceHealthCellProps) => {
	return (
		<div className="flex items-center space-x-3">
			<Tooltip position='up' text={`${health === null ? 'Not enough data to determine source health' : 'Source Health'}`}>
				<HealthIndicator health={health} />
			</Tooltip>
			<span className={size === 'sm' ? 'text-xs font-normal' : 'text-sm font-medium'}>{health === null ? 'N/A' : `${health === 0 ? 0 : health.toFixed(3)}%`}</span>
		</div>
	);
};
